import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { bool, string } = proptypes;
import {
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { RedirectTag, useHelmet } from '@thd-nucleus/thd-helmet';
import { RedirectContext } from './RedirectContext';
import { hasNoMetadata, isValidCanonical } from './rules/collection-redirect-rules';
import { getPathWithMergedParams, handleErrors, ERROR_HANDLING_EXPERIENCE } from '../utils/redirector-utils';

const collectionHandler = ({ data, error, props }) => {

  const {
    bypass,
    collectionId,
    path
  } = props;

  const errors = handleErrors(error, ERROR_HANDLING_EXPERIENCE.GENERIC);
  if (errors) {
    return new RedirectTag(errors, bypass);
  }
  const noMeta = hasNoMetadata({ data, collectionId });
  if (noMeta) {
    return new RedirectTag(noMeta, bypass);
  }

  const collectionCanonical = isValidCanonical({ data, path });
  if (collectionCanonical) {
    return new RedirectTag(collectionCanonical, bypass);
  }

  return null;
};

export const CollectionRedirector = ({ collectionId }) => {

  const { pathWithQueryParams, bypass } = useContext(RedirectContext);
  const [path] = pathWithQueryParams.split('?');
  const props = {
    pathWithQueryParams,
    path,
    collectionId,
    bypass
  };

  const opts = {
    variables: {
      collectionId
    }
  };

  const { data, error } = useDataModel('collection', opts);
  useHelmet('collectionRedirector', { data, error, props }, collectionHandler, [collectionId]);

  return null;
};

CollectionRedirector.propTypes = {
  collectionId: string.isRequired
};

CollectionRedirector.defaultProps = {};

CollectionRedirector.dataModel = {
  collection: params({ collectionId: stringType().isRequired() }).shape({
    collectionId: stringType(),
    metadata: shapeType({
      canonicalUrl: stringType(),
    })
  })
};

CollectionRedirector.displayName = 'CollectionRedirector';
